import { Status } from "@/types";

interface StatusBadgeProps {
  status: Status;
  border?: boolean;
  className?: string;
}

export const statusColorMap: Record<Status, string> = {
  Pending: "#fbbf24", // amber-400
  Delivered: "#22c55e", // green-500
  Deleted: "#9ca3af", // gray-400
  Discarded: "#f97316", // orange-500
  Archived: "#a3a3a3", // gray-400 fallback
  Created: "#3b82f6", // blue-500 fallback
  Edited: "#f59e42", // orange-400 fallback
};

const StatusBadge = ({ status, border = false, className = "" }: StatusBadgeProps) => {
  if (border) {
    return (
      <span
        className={`pl-3 py-1 flex items-center text-xs font-semibold ${className}`}
        style={{
          borderLeft: `4px solid ${statusColorMap[status]}`,
          background: "transparent",
        }}
      >
        {status}
      </span>
    );
  }
  // Badge style (default)
  const colorClass = {
    Pending: "bg-amber-100 text-amber-700",
    Delivered: "bg-green-100 text-green-700",
    Deleted: "bg-gray-200 text-gray-600",
    Discarded: "bg-orange-100 text-orange-700",
    Archived: "bg-gray-200 text-gray-600",
    Created: "bg-blue-100 text-blue-700",
    Edited: "bg-orange-100 text-orange-700",
  }[status] || "bg-gray-100 text-gray-700";
  return (
    <span className={`px-2 py-0.5 rounded text-xs font-semibold ${colorClass} ${className}`}>{status}</span>
  );
};

export default StatusBadge;
